import { render, staticRenderFns } from "./VotesNext.vue?vue&type=template&id=526e8536&scoped=true"
import script from "./VotesNext.vue?vue&type=script&lang=js"
export * from "./VotesNext.vue?vue&type=script&lang=js"
import style0 from "./VotesNext.vue?vue&type=style&index=0&id=526e8536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526e8536",
  null
  
)

export default component.exports